import { Menu, MenuItem, Select } from '@mui/material';
import { logout } from 'app/reducers/user';
import CustomIcon from 'components/customIcon';
import React, { useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import { ReactComponent as ArrowIcon } from '../assets/img/arrow.svg';
import { request } from 'app/api';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { get } from 'lodash';
import cn from 'classnames';
import { ReactComponent as OrderIcon } from '../assets/icons/pencil.svg';
import { ReactComponent as DashboardIcon } from '../assets/icons/dashboard.svg';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

import PopupState, { bindHover, bindMenu } from 'material-ui-popup-state';
import HoverMenu from 'material-ui-popup-state/HoverMenu';
import classNames from 'classnames';

const Header = ({ languages, user, t }) => {
    const [sidebarOpen, setSidebarOpen] = useState(false);

    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { pathname } = useLocation();

    const pages = useMemo(() => {
        const pagesObj = {};
        user?.pages?.map((page) => (pagesObj[page] = true));
        return pagesObj;
    }, [user]);

    const myHotelSubmenu = useMemo(
        () => [
            { name: 'general-information', title: t('GENERAL') },
            { name: 'rooms', title: t('ROOMS') },
            { name: 'rates', title: t('RATES') },
            { name: 'prices', title: t('PRICES') },
            { name: 'services', title: t('SERVICES') },
            { name: 'promo-codes', title: t('PROMO_CODE') },
            { name: 'integration', title: t('INTEGRATION') },
            { name: 'booking-com', title: t('BOOKING_COM') },
            { name: 'design', title: t('DESIGN') },
            { name: 'hotel-users', title: t('USERS') },
        ],
        [t],
    );

    const dashboardSubmenus = useMemo(
        () => [
            { name: 'income-report', title: t('INCOME_REPORT') },
            { name: 'service-report', title: t('SERVICE_REPORT') },
            { name: 'dashboard', title: t('KPI_DASHBOARD') },
        ],
        [t],
    );

    const submenuSettings = useMemo(
        () => [
            { name: 'keys', title: t('KEYS') },
            { name: 'url', title: t('URL') },
        ],
        [t],
    );

    const handleChangeActiveHotel = (hotelId) => {
        const newpath = pathname.indexOf('/', 1) > 0 ? pathname.slice(0, pathname.indexOf('/', 1)) : pathname;

        request({
            method: 'post',
            url: `employee/active-hotel/${hotelId}`,
            success: () => {
                Swal.fire({
                    icon: 'success',
                    text: 'Successfully changed!',
                    showConfirmButton: false,
                    timer: 1000,
                }).then((result) => {
                    navigate(newpath);
                    window.location.reload();
                });
            },
            fail: () => {},
        });
    };

    const handleSignOut = () => {
        setAnchorEl(null);
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');
        dispatch(logout());
    };

    const handleChangeLanguage = (lang) => () => {
        setAnchorEl(null);

        request({
            method: 'post',
            url: `employee/active-language/${lang.id}`,
            success: () => {},
        });

        localStorage.setItem('locale', lang.code);
        window.location.reload();
    };

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <header className="header">
            <div className="logo-part">
                <CustomIcon onClick={() => setSidebarOpen(true)} className="sidebar-toggle-button" icon="list" />
                <h3>easy</h3>
            </div>

            <div className="menus-part">
                <ul className={classNames('list', { active: sidebarOpen })}>
                    {pages.ORDERS ? (
                        <Link to="/timeline">
                            <li
                                className={cn('list-item', {
                                    active: pathname === '/timeline',
                                })}
                            >
                                <CustomIcon icon="grid" className="iconRoot" />
                                <span className="list-item__text">{t('TIMELINE')}</span>
                            </li>
                        </Link>
                    ) : null}

                    {pages.DASHBOARDS ? (
                        <PopupState variant="popover" popupId="demo-popup-menu">
                            {(popupState) => (
                                <React.Fragment>
                                    <li
                                        className={cn('list-item myhotel', {
                                            active: !!dashboardSubmenus.find((item) => pathname === `/${item.name}`),
                                        })}
                                        {...bindHover(popupState)}
                                    >
                                        <DashboardIcon className="iconRoot" />
                                        <span className="name list-item__text">{t('DASHBOARD')}</span>
                                        <KeyboardArrowDownIcon />
                                    </li>

                                    <HoverMenu className="submenu" {...bindMenu(popupState)}>
                                        {dashboardSubmenus.map((item, i) => (
                                            <Link
                                                key={i}
                                                className={cn('', {
                                                    active: pathname === `/${item.name}`,
                                                })}
                                                onClick={() => {
                                                    popupState.close();
                                                }}
                                                to={item.name}
                                            >
                                                <MenuItem>{item.title}</MenuItem>
                                            </Link>
                                        ))}
                                    </HoverMenu>
                                </React.Fragment>
                            )}
                        </PopupState>
                    ) : null}

                    {pages.ORDERS ? (
                        <Link to="/orders">
                            <li
                                className={cn('list-item', {
                                    active: pathname === '/orders',
                                })}
                            >
                                <OrderIcon className="iconRoot" />
                                <span className="list-item__text">{t('ORDERS')}</span>
                            </li>
                        </Link>
                    ) : null}

                    {pages.HOTELS ? (
                        <Link to="/hotels">
                            <li
                                className={cn('list-item', {
                                    active: pathname === '/hotels',
                                })}
                            >
                                <CustomIcon icon="hotel" className="iconRoot" />
                                <span className="list-item__text">{t('HOTELS')}</span>
                            </li>
                        </Link>
                    ) : null}

                    {pages.EMPLOYEE ? (
                        <Link to="/employee">
                            <li
                                className={cn('list-item', {
                                    active: pathname === '/employee',
                                })}
                            >
                                <CustomIcon icon="user" className="iconRoot" />
                                <span className="list-item__text">{t('USERS')}</span>
                            </li>
                        </Link>
                    ) : null}

                    {pages.MYHOTEL ? (
                        <PopupState variant="popover" popupId="demo-popup-menu">
                            {(popupState) => (
                                <React.Fragment>
                                    <li
                                        className={cn('list-item myhotel', {
                                            active: !!myHotelSubmenu.find((item) => pathname === `/${item.name}`),
                                        })}
                                        {...bindHover(popupState)}
                                    >
                                        <CustomIcon icon="building" className="iconRoot" />
                                        <span className="name list-item__text">{t('MY_HOTEL')}</span>

                                        <KeyboardArrowDownIcon />
                                    </li>

                                    <HoverMenu className="submenu" {...bindMenu(popupState)}>
                                        {myHotelSubmenu.map((item, i) => (
                                            <Link
                                                key={i}
                                                className={cn('', {
                                                    active: pathname === `/${item.name}`,
                                                })}
                                                onClick={() => {
                                                    popupState.close();
                                                }}
                                                to={item.name}
                                            >
                                                <MenuItem>{item.title}</MenuItem>
                                            </Link>
                                        ))}
                                    </HoverMenu>
                                </React.Fragment>
                            )}
                        </PopupState>
                    ) : null}

                    {/* {pages.PRICES ? (
            <Link to="/prices">
              <li
                className={cn("list-item", {
                  active: pathname === "/prices",
                })}
              >
                <CustomIcon icon="calendar-money" className="iconRoot" />
                <span className="list-item__text">{t("PRICES")}</span>
              </li>
            </Link>
          ) : null} */}

                    {/* {pages.INTEGRATION ? (
            <Link to="/integration">
              <li
                className={cn("list-item", {
                  active: pathname === "/integration",
                })}
              >
                <CloseFullscreenOutlinedIcon className="iconRoot" />
                <span className="list-item__text">{t("INTEGRATION")}</span>
              </li>
            </Link>
          ) : null} */}

                    {/* {pages.PRICES ? (
            <Link to="/design">
              <li
                className={cn("list-item", {
                  active: pathname === "/design",
                })}
              >
                <CustomIcon className="iconRoot" icon="custom-design" />
                <span className="list-item__text">{t("DESIGN")}</span>
              </li>
            </Link>
          ) : null} */}

                    {pages.SETTINGS ? (
                        <PopupState variant="popover" popupId="demo-popup-menu">
                            {(popupState) => (
                                <React.Fragment>
                                    <li
                                        className={cn('list-item myhotel', {
                                            active: !!submenuSettings.find((item) => pathname === `/${item.name}`),
                                        })}
                                        {...bindHover(popupState)}
                                    >
                                        <CustomIcon icon="settings" className="iconRoot" />
                                        <span className="list-item__text">{t('SETTINGS')}</span>

                                        <KeyboardArrowDownIcon />
                                    </li>

                                    <HoverMenu className="submenu" {...bindMenu(popupState)}>
                                        {submenuSettings.map((item, i) => (
                                            <Link
                                                key={i}
                                                className={cn('', {
                                                    active: pathname === `/${item.name}`,
                                                })}
                                                onClick={() => {
                                                    popupState.close();
                                                }}
                                                to={item.name}
                                            >
                                                <MenuItem>{item.title}</MenuItem>
                                            </Link>
                                        ))}
                                    </HoverMenu>
                                </React.Fragment>
                            )}
                        </PopupState>
                    ) : null}

                    {/* {pages.BILLING ? (
            <Link to="/billing">
              <li
                className={cn("list-item", {
                  active: pathname === "/billing",
                })}
              >
                <CustomIcon icon="billing" className="iconRoot" />
                <span className="list-item__text">{t("BILLING")}</span>
              </li>
            </Link>
          ) : null} */}
                </ul>
                <div onClick={() => setSidebarOpen(false)} className={classNames('background', { active: sidebarOpen })}></div>
            </div>

            <div className="profile-part">
                <Select
                    className="hotel-select"
                    IconComponent={ArrowIcon}
                    sx={{ '& fieldset': { boxShadow: 'none !important' } }}
                    onChange={(e) => {
                        handleChangeActiveHotel(e.target.value);
                    }}
                    MenuProps={{
                        PopoverClasses: {
                            paper: 'hotels_select_body beauty_scrollbar',
                        },
                    }}
                    defaultValue={get(user, 'activeHotelId')}
                >
                    {get(user, 'hotel', []).map((option) => (
                        <MenuItem key={option.id ?? option.value} value={option.id ?? option.value}>
                            {option.title ?? option.name}
                        </MenuItem>
                    ))}
                </Select>

                <div className="vertical-line" />

                <div className="notification">
                    <CustomIcon icon="bell" />
                </div>

                <div className="profile-button" onClick={handleClick}>
                    <CustomIcon icon="profile" />
                </div>

                <Menu
                    PopoverClasses={{
                        paper: 'hotels_select_body language beauty_scrollbar',
                    }}
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                >
                    {languages?.map((lang) => (
                        <MenuItem selected={lang.code === localStorage.locale} key={lang.code} onClick={handleChangeLanguage(lang)}>
                            {lang.code.toUpperCase()}
                        </MenuItem>
                    ))}
                    <MenuItem className="sign-out" onClick={handleSignOut}>
                        <div className="sign-out">{t('SIGN_OUT')}</div>
                    </MenuItem>
                </Menu>
            </div>
        </header>
    );
};

export default Header;
